import { kee } from './keecloak'

export default {
  computed: {
    isAdmin() {
      return kee.userInfo.roles['references']?.includes('admin')
    },
    isInternalUser() {
      return kee.userInfo.roles.realm.includes('internal-eepos-user')
    },
    isGeneralUser() {
      return kee.userInfo.roles.realm.includes('general-eepos-user')
    },
  },
}
